import { WSTable } from "@wingspanhq/fe-component-library";
import { InvoiceRow, PayerRow, WorkLog } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { getColumns } from "./columns";

export type TableItemData = WorkLog;

type Props = {
  workLogs: WorkLog[];
  /** Client rows keyed by `payerEngagementId` — see `usePayersMap`. */
  payersMap: Map<string, PayerRow>;
  invoicesMap?: Map<string, InvoiceRow>;
  onRowClick?: (workLog: WorkLog) => void;
};

export const TableWorkLogsPayeeView: React.FC<Props> = props => {
  const tableData = useMemo(() => {
    return props.workLogs.map(workLog => ({
      id: workLog.id ?? "",
      data: workLog
    }));
  }, [props.workLogs]);

  const columns = useMemo(
    () =>
      getColumns({
        payersMap: props.payersMap,
        invoicesMap: props.invoicesMap
      }),
    [props.payersMap, props.invoicesMap]
  );

  return (
    <WSTable<TableItemData>
      tableData={tableData}
      columns={columns}
      onRowClick={
        props.onRowClick ? item => props.onRowClick!(item.data) : undefined
      }
    />
  );
};
